import * as yup from 'yup';

import { BulkUploadFormFields } from 'src/types/bulkUpload';
import type { FilePickerFileTypesKeys } from 'src/types/file';

const fileValidationSchema = yup.object({
  id: yup.string().required(),
  loading: yup.boolean().isFalse(),
  valid: yup.boolean().isTrue(),
});

export const bulkUploadFormValidationSchema = yup.object({
  [BulkUploadFormFields.items]: yup
    .array()
    .of(fileValidationSchema)
    .length(1)
    .nullable()
    .required(),
});

export const ACCEPTED_FILE_TYPES: FilePickerFileTypesKeys[] = ['csv', 'xls', 'xlsx'];
